import styled from 'styled-components';
import { darken } from 'polished';
import { StyledButton as Button } from '../CommonComponents/Button';
import getImagePath from '../CommonUtils/getImagePath';

export const Container = styled.div`
  text-align: center;
`;

export const Title = styled.h2`
  font-weight: 300;
  margin: 0 0 35px 0;
  padding: 0;
  color: #777;
  font-size: 27px;
  line-height: 1;
`;

export const Text = styled.p`
  margin: 0;
`;

export const Belt = styled.div`
  max-width: 900px;
  margin: 0 auto;
  position: relative;
`;

export const Section = styled.section`
  padding: 50px;
  margin: 0 auto;
`;

export const AnchorButton = styled.a`
  border: none;
  height: 40px;
  line-height: 40px;
  color: white;
  font-weight: 600;
  padding: 0 15px;
  margin: 0;
  cursor: pointer;
  display: block;
  font-size: 15px;
  overflow: hidden;
  border-radius: 5px;
  background: #5abee4;
  text-shadow: rgba(0, 0, 0, 0.1) 1px 1px 0;
  font-family: 'Open Sans', helvetica, arial, sans-serif;
  -webkit-font-smoothing: antialiased;

  i {
    font-style: normal;
    font-size: 14px;
    display: inline-block;
    line-height: 40px;
    margin: 0 0 0 5px;
  }
`;

export const OptionText = styled(Text)`
  margin: 15px 0;
  font-weight: bold;
`;

export const Intro = styled(Section)`
  background: #0078d4 url(${getImagePath('intro-bg.png')}) repeat-x left bottom;

  ${Belt} {
    max-width: 600px;
    color: white;
    line-height: 1.5;
    font-size: 20px;
    font-weight: 400;
  }

  ${Title} {
    font-size: 36px;
    margin: 0 0 25px 0;
    color: white;
    font-weight: 600;
  }

  button {
    float: none;
    display: inline;
    font-size: 20px;
    height: 50px;
    padding: 0 25px;
    margin: 0;
    border: none;
    background: ${darken(0.2, '#5abee4')};
    text-shadow: rgba(0, 0, 0, 0.1) 1px 1px 0;
    color: white;
    box-shadow: none;
    transition: all, 0.3s, ease-in-out;

    i.fa-plus {
      font-size: 12px;
      display: inline-block;
      margin: -8px 10px 0 0;
      vertical-align: middle;
    }

    i.fa-user {
      font-size: 23px;
      margin: 0;
      vertical-align: middle;
    }

    &:hover {
      background: ${darken(0.3, '#5abee4')};
    }
  }

  ${Text} {
    margin-bottom: 30px;
  }
`;

export const SampleClient = styled(Section)`
  text-align: left;

  img {
    display: block;
    width: 46%;
    height: auto;
    border: 1px solid #ccc;
    float: right;
    border-radius: 4px;
    margin: 0 0 0 45px;
  }

  ${Text} {
    color: #777;
    line-height: 1.6;
    font-size: 16px;
  }

  ul,
  li {
    display: block;
    list-style: none;
    margin: 20px 0 0 0;
    padding: 0;
  }

  li {
    margin: 0 0 5px 0;
  }

  ${AnchorButton} {
    display: inline-block;
    margin: 20px 0 0 0;
    background: #ff9e13;
    border: none;
    box-shadow: none;
    font-weight: 400;
    font-size: 18px;

    &:hover {
      color: white;
      background: ${darken(0.1, '#ff9e13')};
    }
  }
`;

export const LinkButton = styled(Button.Link)`
  color: #22a0d0;
  text-decoration: none;

  &:hover,
  &:active {
    color: #176d8e;
  }
`;
